export default __webpack_public_path__ + "static/healthcare-9ef446978c09e7b00184843d1b410a96.png";